import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { take } from 'rxjs';
import { DeviceListService } from 'src/app/services/device-list/device-list.service';
import { PoprPriority } from 'src/app/shared/components/popr/popr-priority.enum';
import { PoprService } from 'src/app/shared/components/popr/popr.service';
import { DeviceInfo, RemoveTrustedDeviceData } from 'src/app/shared/models/DeviceInfoResponse';
import { GdlService } from 'src/app/shared/services/gdl-service/gdl.service';

@Component({
  selector: 'wpro-device-table',
  templateUrl: './device-table.component.html',
  styleUrls: ['./device-table.component.css'],
  standalone: false
})
export class DeviceTableComponent implements OnInit{

  devices: DeviceInfo[];
  deviceCount: number;
  isAscending = false;
  showDeletePopUp = false;
  deleteDevice: RemoveTrustedDeviceData;
  allDeviceID = '';
  gdlTypeServer = 'server';
  gdlContextType: string;

  @Output() isAPIFailLoginScreen = new EventEmitter<boolean>();

  constructor(
    private deviceListService: DeviceListService,
    private gdlService: GdlService,
    private poprService: PoprService
  ) {}

  ngOnInit(): void {
    this.getDevicesList();
  }

  getDevicesList(): void {
    this.deviceListService.getTrustedDeviceInfo().pipe(
      take(1)
    ).subscribe((response) => {
      this.devices = response.output?.deviceInfo;
      this.deviceCount = this.devices?.length || 0;
      if (this.deviceCount > 0) {
        this.sortDevices('lastLoginTime', this.isAscending);
        this.convertToDate();
      }
      if(this.deviceCount > 10){
        this.devices.splice(10, this.devices.length);
        this.deviceCount = this.devices.length;
      }
    }, (httpError) => {
      this.handleError(httpError, false);
      // TODO: GDL
    });
  }

  sortDevices(columnName: string, isAscDesc: boolean): void {
    if (!isAscDesc) {
      columnName !== 'lastLoginTime' ?
      this.devices.sort((a, b) => a[columnName] < b[columnName] ? 1 : a[columnName] > b[columnName] ? -1 : 0) :
      this.devices.sort((a, b) => new Date(a[columnName]).getTime() < new Date(b[columnName]).getTime() ? 1 : new Date(a[columnName]).getTime() > new Date(b[columnName]).getTime() ? -1 : 0);
      this.isAscending = !this.isAscending;

    } else {
      columnName !== 'lastLoginTime' ?
      this.devices.sort((a, b) => a[columnName] > b[columnName] ? 1 : a[columnName] < b[columnName] ? -1 : 0) :
      this.devices.sort((a, b) => new Date(a[columnName]).getTime() > new Date(b[columnName]).getTime() ? 1 : new Date(a[columnName]).getTime() < new Date(b[columnName]).getTime() ? -1 : 0);
      this.isAscending = !this.isAscending;
    }
  }

  convertToDate(): void {
    this.devices.forEach((device) => {
      const dateString = device.lastLoginTime;
      const dateAsUTC = this.parseAsUTC(dateString);
      device.lastLoginTime = dateAsUTC.toISOString();
    });
  }

  parseAsUTC(dateString: any): Date {
    const months = ['january','february','march','april','may','june','july','august','september','october','november','december'];
    const dateArray = dateString.split(/\W/);
    return new Date(Date.UTC(dateArray[2], months.indexOf(dateArray[0].toLowerCase()), dateArray[1], dateArray[3], dateArray[4]));
  }

  onRemoveDevice(deviceid: string): void {
    this.showDeletePopUp = true;
    this.deleteDevice = { isDoNotShowPopupChecked: this.showDeletePopUp , deviceId: deviceid };
    this.gdlService.captureInteractionEvent('click', 'wpro-loginsecurity-deletedevice');
  }

  onRemoveAllDevice(): void {
    for(const device of this.devices){
      this.allDeviceID += (device.deviceId) + ',';
    }
    this.showDeletePopUp = true;
    this.deleteDevice = { isDoNotShowPopupChecked: this.showDeletePopUp , deviceId: this.allDeviceID };
    this.gdlService.captureInteractionEvent('click', 'wpro-loginsecurity-removealldevices');
  }

  handleError(err: HttpErrorResponse, isRemoveDevice: boolean): void {
    isRemoveDevice ? this.poprService.createToast(PoprPriority.ERROR, '{"translateKey": "errorNotification.removeDeviceDescription"}') : this.isAPIFailLoginScreen.emit(true);

    this.gdlContextType = isRemoveDevice ? 'DELETE' : 'GET';
    this.gdlService.captureGdlErrorMessages(this.gdlTypeServer, err, this.gdlContextType);
  }

  confirmRemoveDevice(): void {
    this.deviceListService.removeDevice(this.deleteDevice.deviceId).pipe(
      take(1)
    ).subscribe((response) => {
      this.getDevicesList();
    }, (httpError) => {
      this.handleError(httpError, true);
    });
  }

  getDeviceIcon(deviceNickName: string): string {
    const device = deviceNickName.split(' ')[0];
    // TODO: Revise if condition once API returns correct deviceNickName
    return device === 'Mac' || device === 'Windows' ? 'communication_devices_computer' : 'communication_devices_mobile';
  }
}
